import {NgModule} from '@angular/core';

import {InformationAssureTableListeComponent} from './information-assure-table.liste.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [InformationAssureTableListeComponent],
  declarations: [InformationAssureTableListeComponent],
  providers: [],
})
export class InformationAssureTableListeModule {
}
